import { ConfigStateService } from '@abp/ng.core';
import { Component, OnInit } from '@angular/core';
import { UserService } from './proxy/user';
import { UserDto, UserRequestDto } from './proxy/integrations/seedling-supply-service/dto';
import { Applications } from './shared/enums/applications';
import { firstValueFrom } from 'rxjs';
import { LocalDbService } from './shared/local-db/LocalDbService';
import { AppConsts } from './shared/AppConsts';

@Component({
  standalone: false,
  selector: 'app-root',
  template: `
    <abp-loader-bar></abp-loader-bar>
    <abp-dynamic-layout></abp-dynamic-layout>
  `,
})
export class AppComponent implements OnInit {

  constructor(private readonly configState: ConfigStateService,
    private readonly localDbService: LocalDbService,
    private readonly userService: UserService,) { }

  ngOnInit(): void {
    this.getUserData();
  }

  async getUserData(): Promise<UserDto> {
    const user = this.configState.getOne(AppConsts.CurrentUser);
    if (!user) {
      return;
    }

    const request: UserRequestDto = {
      email: user.email,
      roles: user.roles.toString(),
      uniqueId: user.id,
      app: Applications.ReceptionApp.toString(),
    };

    try {
      const userData = await firstValueFrom(this.userService.userDataByUser(request));
      await this.localDbService.clearUser();
      await this.localDbService.addUser(userData);
      return userData;
    } catch {
      const localUser = await this.localDbService.getUser();
      if (localUser) {
        return localUser;
      } else {
        return undefined;
      }
    }
  }
}
